import apiClient from "./index";

export const cartApi = {
	// 장바구니 추가
	addToCart: async (cartData) => {
		return await apiClient.post('/cart', cartData);
	},

	// 장바구니 조회
	getCartItems: async () => {
		return await apiClient.get('/cart');
	},

	// 장바구니 수정
	updateCartItem: async (updateData) => {
		return await apiClient.patch(`/cart`, updateData);
	},
};